/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type GetReturningSponsorInviteCodeQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetReturningSponsorInviteCodeQuery = {
  returningSponsorInvite: Pick<
    Types.ReturningSponsorInvite,
    "status" | "invite_code" | "company_name"
  >;
};

export const GetReturningSponsorInviteCodeDocument = gql`
  query GetReturningSponsorInviteCode {
    returningSponsorInvite {
      status
      invite_code
      company_name
    }
  }
`;

/**
 * __useGetReturningSponsorInviteCodeQuery__
 *
 * To run a query within a React component, call `useGetReturningSponsorInviteCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReturningSponsorInviteCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReturningSponsorInviteCodeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReturningSponsorInviteCodeQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetReturningSponsorInviteCodeQuery,
    GetReturningSponsorInviteCodeQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetReturningSponsorInviteCodeQuery,
    GetReturningSponsorInviteCodeQueryVariables
  >(GetReturningSponsorInviteCodeDocument, baseOptions);
}
export function useGetReturningSponsorInviteCodeLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetReturningSponsorInviteCodeQuery,
    GetReturningSponsorInviteCodeQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetReturningSponsorInviteCodeQuery,
    GetReturningSponsorInviteCodeQueryVariables
  >(GetReturningSponsorInviteCodeDocument, baseOptions);
}
export type GetReturningSponsorInviteCodeQueryHookResult = ReturnType<
  typeof useGetReturningSponsorInviteCodeQuery
>;
export type GetReturningSponsorInviteCodeLazyQueryHookResult = ReturnType<
  typeof useGetReturningSponsorInviteCodeLazyQuery
>;
export type GetReturningSponsorInviteCodeQueryResult =
  ApolloReactCommon.QueryResult<
    GetReturningSponsorInviteCodeQuery,
    GetReturningSponsorInviteCodeQueryVariables
  >;
